import { _ as a } from "../../_virtual/_nodeUtil.js";
import s from "./_freeGlobal.js";
(function(e, o) {
  var f = s, i = o && !o.nodeType && o, r = i && !0 && e && !e.nodeType && e, c = r && r.exports === i, t = c && f.process, p = function() {
    try {
      var n = r && r.require && r.require("util").types;
      return n || t && t.binding && t.binding("util");
    } catch {
    }
  }();
  e.exports = p;
})(a, a.exports);
//# sourceMappingURL=_nodeUtil.js.map
